import useContract from '@shared/hooks/useContract'
import useI18n from '@shared/hooks/useI18n'
import useProduct from '@shared/hooks/useProduct'

import { DateTimeHelper } from '@shared/helpers/DateTime'
import { isRequired } from '@shared/utils/CustomErrors'

import { GENDER } from '@shared/config/constants'

// HOOKS
const { getCaveats } = useContract()
const { t, te } = useI18n()
const { getCategoryIdFromProduct, getSelectedProductsOfPerson } = useProduct()

export default {
  getPersonDetails(person = isRequired('person'), index = isRequired('index')) {
    const __number = index + 1
    const __selectedProducts = person?.products?.products ? getSelectedProductsOfPerson(person.products.products) : []
    const __recommendations = person.recommendations.map(productId => {
      return Object.assign({}, person.products.products[productId], {
        productId,
        categoryId: getCategoryIdFromProduct(productId),
      })
    })
    const __age = DateTimeHelper.getAge(person.personData.dateOfBirth)

    let icon
    if (__age >= 18) {
      icon = person.personData.gender === GENDER.MALE ? 'man' : 'woman'
    } else if (__age < 18 && __age >= 5) {
      icon = person.personData.gender === GENDER.MALE ? 'boy' : 'girl'
    } else if (__age < 5 && __age >= 0) {
      icon = 'baby'
    } else {
      icon = 'unborn'
    }

    return {
      number: index + 1,
      age: __age,
      icon,
      firstName: person.personData.firstName ?? (te('person.person') ? t('person.person', { number: __number }) : null),
      lastName: person.personData.lastName,
      firstNameAndAge: (person.personData.firstName ?? (te('person.person') ? t('person.person', { number: __number }) : null)) + ' (' + __age + ')',
      total: parseFloat(
        __selectedProducts
          .reduce((total, product) => {
            total += product.price.price
            return total
          }, 0)
          .toFixed(2)
      ),
      caveats: getCaveats(person),

      // @note don't use `products` or `recommendations` as a name, as it's already in use by data from backend
      selectedProducts: __selectedProducts,
      productRecommendations: __recommendations,
    }
  }
}
